import { Navigate } from "react-router-dom";
import { useAuth } from "@/store/AuthStore";
import FullLoader from "@/components/base/FullLoader";

// Redirige al inicio según el rol del usuario autenticado.
const RootRedirect = () => {
  const { session, profile, loading } = useAuth();

  if (loading) return <FullLoader label="Cargando tu ecosistema..." />;
  if (!session) return <Navigate to="/acceso" replace />;
  return <Navigate to={profile?.role === "asesor" ? "/asesor" : "/admin"} replace />;
};

export default RootRedirect;